import styled from "styled-components";

export const WheelOfJackpotbetLogoDefaultBox = styled.div`
    width: 200px;
    height: 96px;
    background-size: 100%;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_logo_png.toString()});   
    margin-left: -8px;
    z-index: 1;

    /* @media ${({theme}) => `${theme.mediaQuery.mAndAbove} and ${theme.mediaQuery.landscape}`} {
        display: none;
    } */
`;